module.exports = __webpack_public_path__ + "static/media/3-_DSC0900.bac63967.jpg";